import React, { Component, useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { TransitionIn } from "Components/Transition";
import Ajax from "Pub/js/ajax";
import classNames from "classnames";
import _ from "lodash";
import {
    updateGroupList,
    toggleEditStatus,
    initGroups,
    setUpdateHomePageFun,
    setEmpty,
    setAppGroupData,
    setHelpHint,
    setDefaultAppGroupData,
    setRespWorkbench,
    setWorkbenchConfig,
} from "Store/GridLayout/action";
import { setWorkbenchId, setLinkageData } from "Store/appStore/action";
import { langCheck, GetQuery, getWindow, getRatio, isInsideTab } from "Pub/js/utils";
import { getMulti } from "Pub/js/getMulti";
import EmptyContent from "./EmptyContent";
import platform from "Pub/js/platform";
// import TabsLink from "../../../layout/headerComponents/TabsLink";
import { setStore, getStore } from "Pub/js/storageUtils";
import { getScale, initDesktopApp, GRID_COLS, getGridRowHeight, getEffectiveLinkData } from "../utilService";
const { ajax, PubSub } = platform;
/**
 * 工作桌面 首页 页面
 * 各个此贴应用及工作台中的小部件 通过 js 片段进行加载渲染
 */
class Home extends Component {
    constructor(props) {
        super(props);
        this.urlObj = GetQuery(this.props.location.search);
        this.defualtAppGroupMap = {}; //默认聚合应用数据
        this.state = {
            layout: {
                margin: [10, 10],
                containerPadding: [0, 0],
                rowHeight: 175,
                calWidth: 175,
            },
            groups: [],
            showEmpty: false,
            json: {},
            loadable: false,
            showDragModal: false,
            showPage: false,
            noCloudCache: false, //bip菜单缓存，没有缓存时进入编辑态重新查一下桌面
        };
    }

    updateHomePage = callback => {
        const currentBench = this.props.benchData.find(item => item.active);
        if (!currentBench) {return;}

        Ajax({
            url: `/nccloud/platform/appregister/queryworkbench.do`,
            info: {
                name: langCheck("home-000000", true, this.state.json) /* 国际化处理： 首页*/,
                action: langCheck("home-000001", true, this.state.json), /* 国际化处理： 首页加载*/
            },
            data: {
                relateid: "",
                isuser: "1",
                workbenchid: currentBench.workbenchid,
            },
            loading: true,
            success: ({ data: { data, success, error } }) => {
                this.setState({ showPage: true });
                if (success && data && data.length > 0) {
                    this.props.setWorkbenchId(data[0].pk_workbench);
                    this.props.setLinkageData(getEffectiveLinkData(data[0].workbenchLinkConfigShowVOS, data[0].groups));
                    if (data[0].groups.length === 0) {
                        this.setState(
                            { showEmpty: true },
                            () => {
                                this.props.setEmpty(true);
                            },
                        );
                    } else {
                        this.setState(
                            {
                                showEmpty: false,
                                noCloudCache: data[0].no_cloud_cache,
                            },
                            () => {
                                this.props.setEmpty(false);
                            },
                        );

                        // 聚合应用数据
                        let appGroupMap = initDesktopApp(data[0].groups, a => {
                            // 小部件刷新间隔存到window上小部件使用
                            if (a.appparams && !isNaN(a.appparams.refresh_time)) {
                                window.widgetRefreshTimeMap[a.appcode] = a.appparams.refresh_time * 60; // 单位改成分钟了
                            }
                        });
                        this.props.setDefaultAppGroupData(_.cloneDeep(appGroupMap)); //设置默认聚合应用
                        this.props.setAppGroupData(appGroupMap); //设置聚合应用
                    }
                    this.setState({ groups: data[0].groups });
                    this.props.updateGroupList(data[0].groups);
                    this.props.initGroups(data[0].groups);
                    this.props.setHelpHint(!!data[0].ishint); //设置不再提示是否显示
                    this.props.setRespWorkbench(data[0].isRespWorkbench); //设置是否职责桌面
                    this.props.setWorkbenchConfig(data[0].workbench_configuration);
                } else {
                    if (success && data && data.length === 0) {
                        this.setState(
                            { showEmpty: true },
                            () => {
                                this.props.setEmpty(true);
                            },
                        );
                        this.setState({ groups: [] });
                        this.props.updateGroupList([]);
                    } else {
                        this.setState(
                            { showEmpty: true },
                            () => {
                                this.props.setEmpty(true);
                            },
                        );
                        // Notice({ status: "error", msg: data });
                    }
                }
                callback && callback();
            },
        });
    };
    componentDidMount() {
        this.mountUpdateHomePage();
        this.onWorkbenchReady = PubSub.subscribe("workbenchDataReady", () => {
            // 这里做个兼容，如果工作台数据获取较慢，这个页面先挂载了，走这里
            this.mountUpdateHomePage();
        });
        this.editDesktop = PubSub.subscribe('editDesktop', () => {
            this.handleChangeEditable();
        });
        if (process.env.NODE_ENV !== "development") {
            console.log(`%c workbench was built at: ${WORKBENCH_VERSION} `, "color:#03A9F4");
        }
        let callback = json => {
            //从其他节点跳转到首页标题title改为首页
            if (!isInsideTab()) {
                getWindow().document.title = langCheck("home-title", true, json); // 有项目想改首页页签title，单独加个多语字段支持自定义标题
            }
            this.setState({ json: json });
        };
        getMulti({
            moduleId: "home",
            domainName: "workbench",
            callback,
        });
        this.props.setUpdateHomePageFun(this.updateHomePage);
        //小部件刷新间隔存到window上小部件使用
        if (window.widgetRefreshTimeMap === undefined) {
            window.widgetRefreshTimeMap = {};
        }
        //获取智能分析小部件自动刷新开关
        this.getIntellivAutoRefreshFlag();
    }
    mountUpdateHomePage() {
        // 从职责直接进桌面编辑态或者工作台管理节点进来的不发请求
        if (!this.urlObj.editable && !this.urlObj.pk_responsibility && !this.urlObj.workbenchid) {
            this.updateHomePage();
        }
    }
    componentWillUnmount() {
        this.headerClassList = null;
        PubSub.unsubscribe(this.onWorkbenchReady);
        PubSub.unsubscribe(this.editDesktop);
    }
    //滚动增加阴影
    onScrollEvent = () => {
        if (!document.getElementsByClassName("n-tabs")[0]) {return;}
        let activeTab = document.getElementsByClassName("n-tabs")[0].getElementsByClassName("active") && document.getElementsByClassName("n-tabs")[0].getElementsByClassName("active")[0];
        let width = document.getElementsByClassName("tabs-page")[0].clientWidth || 1000;
        if (activeTab) {
            if (activeTab.offsetLeft) {
                if (+activeTab.offsetLeft > 0 && +activeTab.offsetLeft >= width) {
                    window.nextPageGroup && window.nextPageGroup();
                } else if (+activeTab.offsetLeft < 0) {
                    window.previousPageGroup && window.previousPageGroup();
                }
            }
        }
        this.headerClassList = document.querySelector(".nccwb-header-info").classList;
        if (this.homeContentScroll.scrollTop > 20) {
            if (!this.headerClassList.contains("header-shadow")) {
                this.headerClassList.add("header-shadow");
            }
        } else {
            if (this.headerClassList.contains("header-shadow")) {
                this.headerClassList.remove("header-shadow");
            }
        }
    };

    //切换桌面编辑态
    handleChangeEditable = () => {
        let triggerFunc = () => {
            // 这里先执行onEnterEditable然后再切换编辑态，为了让左侧部件池侧拉挂载时机晚于这个回调（这个回调有一个空桌面展开侧边的逻辑）
            this.props.onEnterEditable(this.state.showEmpty);
            this.props.toggleEditStatus(true);
            // 进桌面编辑态发个事件
            PubSub.publish("onChangeDesktopEditable", true);
            triggerFunc = null;
        };

        if (this.state.noCloudCache) { // 没有BIP菜单缓存时重新查一下桌面，给清除失效使用
            this.updateHomePage(() => { // 这个等新查的数据返回之后再出发桌面编辑，避免快速发起小部件先请求了数据，这个接口返回就置空了
                triggerFunc();
            });
        } else {
            triggerFunc();
        }
    }

    //智能分析小部件自动刷新开关
    getIntellivAutoRefreshFlag = () => {
        if (getStore('intellivAutoRefresh') == null) {
            ajax({
                url: `/nccloud/platform/intellivautorefresh/switch.do`,
                sysAppcode: 10228888,
                async: false,
                success: ({ data, success }) => {
                    if (success) {
                        setStore('intellivAutoRefresh', data);
                    }
                },
            });
        }
    }
    // 根据浏览器缩放比例获取类名
    getClassName = () => {
        const ratio = getRatio(); // 不是150 都按100处理
        const defaultPagewidth = ratio === 150 ? 'adaptive' : 'fixed';
        const { desktopWidth = defaultPagewidth } = getStore("nccCardlAndDesktop") || {};
        let name = '';
        if (ratio === 150) {
            name = `nc-workbench-home-page-${desktopWidth}-150`;
        } else {
            name = `nc-workbench-home-page-${desktopWidth}-100`;
        }
        return name;
    }
    render() {
        let { showEmpty } = this.state;
        const { editable, groups } = this.props;

        let addClassName = this.getClassName();
        // const showTabs = !showEmpty && !editable && groups.length > 0;
        //编辑态空状态
        if (editable) {
            if (groups.length === 0) {
                return null;
                // return (
                //     <EmptyContent 
                //         {...this.props.emptyInfo}
                //     />
                // )
            }
        } else {
            if (showEmpty) {
                return (
                    <div className='nc-workbench-home-page'>
                        <EmptyContent
                            contentText={langCheck("home-000004", true, this.state.json)}
                            btnText={langCheck("home-000005", true, this.state.json)}
                            onBtnClick={() => this.handleChangeEditable()}
                        />
                    </div>
                );
            }
        }
        return (
            // 等分组动画加载完延迟加载首页
            <TransitionIn in={this.state.showPage}>
                <div
                    className={classNames("nc-workbench-home-page", {
                        editable,
                        [addClassName]: !!addClassName && !editable,
                    })}
                    ref={ref => (this.homeContentScroll = ref)}
                    onScrollCapture={() => this.onScrollEvent()}
                >
                    {groups.length > 0 && (
                        <div
                            fieldid='top-info'
                            className={classNames('nccwb-header-info', { editable })}
                            style={this.urlObj.hideNav === "true" ? { top: 8 } : {}}>
                            {/* <TabsLink key={`tabslink${editable}`} editable={editable}/> */}
                            {
                                isInsideTab() ?
                                    null
                                    :
                                    (!editable && (
                                        <div className="tabs-right">
                                            <div className="tabs-right-item" onClick={() => this.handleChangeEditable()}>
                                                <i className='iconfont icon-zhuomianpeizhi' />
                                                {langCheck("home-000014", true, this.state.json) /* 国际化处理： 桌面设置*/}
                                            </div>
                                        </div>
                                    ))
                            }
                        </div>
                    )}
                    <div className="nc-workbench-home-container" id="ncWorkbenchHomePage">
                        {editable && <GridBackground {...this.props} />}
                        {this.props.allowPaint && this.props.renderGroups()}
                    </div>
                </div>
            </TransitionIn>
        );
    }
}

Home.propTypes = {
    updateGroupList: PropTypes.func.isRequired,
    setUpdateHomePageFun: PropTypes.func.isRequired,
};
export default connect(
    state => ({
        allowPaint: state.ifrData.allowPaint,
        groups: state.gridLayoutData.groups,
        editable: state.gridLayoutData.editable,
        margin: state.gridLayoutData.margin,
        benchData: state.appData.workbenchData,
    }),
    {
        updateGroupList,
        setUpdateHomePageFun,
        setEmpty,
        toggleEditStatus,
        initGroups,
        setAppGroupData,
        setHelpHint,
        setDefaultAppGroupData,
        setRespWorkbench,
        setWorkbenchId,
        setLinkageData,
        setWorkbenchConfig,
    },
)(withRouter(Home));

// 编辑态栅格背景
import { SizeMe } from "react-sizeme";
const GridBackground = function GrigBgC(props) {
    const { margin, gridContainerPadding } = props;
    const [rowHeight, setRowHeight] = useState(getGridRowHeight(margin));
    const widthRef = useRef();

    const renderResult = ({ height, width }) => {
        if (widthRef.current && width !== widthRef.current) { // 宽度变化
            const scale = getScale();
            const rH = getGridRowHeight(margin) * scale.narrow;
            setRowHeight(rH);
        }
        widthRef.current = width; // 记录宽度

        const rowCount = Math.ceil(height / (rowHeight + margin));
        let result = [];
        for (let r = 0; r < rowCount; r++) {
            for (let i = 0; i < GRID_COLS; i++) {
                let colDom = <div className="grid-layout-col"></div>;
                result.push(colDom);
            }
        }
        return result;
    };

    return <SizeMe monitorHeight>
        {({ size }) =>
            <div className="grid-layout-col-container">
                <div
                    className="grid-container"
                    style={{
                        gridAutoRows: rowHeight,
                        gridTemplateColumns: `repeat(${GRID_COLS}, auto)`,
                        gridGap: margin,
                        padding: `${gridContainerPadding[1]}px ${gridContainerPadding[0]}px`,
                    }}
                >
                    {renderResult(size)}
                </div>
            </div>
        }
    </SizeMe>;
};